'use client';

import PropTypes from 'prop-types';

export default function BookOutlinePanel({ bookIntro, currentChapter, onChapterSelect, onClose }) {
  if (!bookIntro) {
    return (
      <div className="bg-card rounded-lg border border-border p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold">Book Outline</h2>
          <button
            onClick={onClose}
            className="p-1 rounded-lg hover:bg-accent transition-colors lg:hidden"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <p className="text-muted-foreground text-sm">Book introduction not available</p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border p-6 sticky top-24">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold">Book Outline</h2>
        <button
          onClick={onClose}
          className="p-1 rounded-lg hover:bg-accent transition-colors lg:hidden"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div className="space-y-4">
        {/* Book Introduction */}
        <div className="space-y-2">
          <div className="flex items-center gap-2 text-sm">
            <span className="text-muted-foreground">Author:</span>
            <span className="font-medium">{bookIntro?.author}</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <span className="text-muted-foreground">Date:</span>
            <span className="font-medium">{bookIntro?.date}</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <span className="text-muted-foreground">Theme:</span>
            <span className="font-medium">{bookIntro?.theme}</span>
          </div>
        </div>

        <div className="pt-3 border-t border-border">
          <h3 className="text-sm font-semibold mb-2">Purpose</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {bookIntro?.purpose}
          </p>
        </div>

        {/* Book Outline */}
        {bookIntro?.outline && bookIntro?.outline?.length > 0 && (
          <div className="pt-3 border-t border-border">
            <h3 className="text-sm font-semibold mb-3">Outline</h3>
            <div className="space-y-3">
              {bookIntro?.outline?.map((item, idx) => (
                <div key={idx} className="space-y-1">
                  <div className="flex gap-2">
                    <span className="text-primary font-semibold flex-shrink-0">
                      {item?.section}.
                    </span>
                    <button
                      onClick={() => onChapterSelect?.(idx + 1)}
                      className="text-sm font-medium hover:text-primary transition-colors text-left"
                    >
                      {item?.title}
                    </button>
                  </div>
                  {item?.subsections && (
                    <div className="ml-6 space-y-1">
                      {item?.subsections?.map((sub, subIdx) => (
                        <p key={subIdx} className="text-xs text-muted-foreground">
                          {sub}
                        </p>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

BookOutlinePanel.propTypes = {
  bookIntro: PropTypes?.shape({
    author: PropTypes?.string?.isRequired,
    date: PropTypes?.string?.isRequired,
    theme: PropTypes?.string?.isRequired,
    purpose: PropTypes?.string?.isRequired,
    outline: PropTypes?.arrayOf(PropTypes?.shape({
      section: PropTypes?.string?.isRequired,
      title: PropTypes?.string?.isRequired,
      subsections: PropTypes?.arrayOf(PropTypes?.string)
    }))
  }),
  currentChapter: PropTypes?.number?.isRequired,
  onChapterSelect: PropTypes?.func?.isRequired,
  onClose: PropTypes?.func?.isRequired
};